import React from 'react';
import { ExternalLink } from 'lucide-react';

import { OPEN_IN_KINNSER_LABEL } from './importReportCopy';

/**
 * The way back to the External EMR page a finding or a review item came from.
 *
 * One component for the report's lines and the review items, so the link
 * reads the same wherever the report points outward.
 */
const KinnserLink: React.FC<{ url: string }> = ({ url }) => (
  <a
    href={url}
    target='_blank'
    rel='noopener noreferrer'
    className='inline-flex items-center gap-1 text-sm text-primary underline underline-offset-2'
  >
    {OPEN_IN_KINNSER_LABEL}
    <ExternalLink className='h-3.5 w-3.5' aria-hidden='true' />
  </a>
);

export default KinnserLink;
